import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Create_services = async (data) => {
  const { servicetablename, serviceid } = data || {};

  // 1. Validate inputs

  if (!serviceid?.trim()) {
    return { success: false, error: "Missing service UID" };
  }
  if (!servicetablename?.trim()) {
    return { success: false, error: "Missing servicetablename" };
  }
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {

 
    // Check duplicate accountguid inside company
      const domainQuery = query(
      collection(db, servicetablename),
      where("companyuid", "==", select_company_uid)
    );
    const snapshot = await getDocs(domainQuery);
    if (!snapshot.empty) {
      return { success: false, error: "Service already exists" };
    }

    const parentDocRef = doc(db, servicetablename, select_company_uid);

    // ✅ Save parent document
    const suid = Randomcode(18);
    const savequery = {

      ...data,
      suid,
      status: true,
      companyuid: select_company_uid,
      guid,
    
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(parentDocRef, savequery);

  //
    const serviceDocRef = doc(
      db,
      "companies",
      select_company_uid,
      servicetablename,
      serviceid
    );

    const servicequery = {
      ...data,
        last_bill_date_time: new Date(),
      days:10,
      mode_test:true,
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(serviceDocRef, servicequery);


    return { success: true };
  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
